import React from "react";
import { Notebook } from "@learningblocks/simulations/shared-components";
import { ObjectivesContainer } from "../ObjectivesContainer";
import { Spreadsheet } from "../Spreadsheet";

import IconHexagon from "@learningblocks/protocol-constants/lib/Icons/hexagon-solid";
import "./style.scss";

export function SpreadsheetProtocolSection(props) {
  return (
    <div className="hotspot_book_index_container" aria-hidden={props.collapsed}>
      {props.includeProtocol && (
        <Notebook.IndexBlock className="book_index">
          <Notebook.Header className="book_index_header">
            <Notebook.TitleBlock
              className={`index-titleBlock`}
              title={props.title}
              text={props.description}
              ariaLabel="Lab notebook section heading."
            />
            {!props.noDrawerToggle && (
              <Notebook.ProtocolDrawerIcon
                className="index-icon"
                collapsed={false}
                toggleCollapse={props.setNotebookVisible}
              />
            )}
            <Notebook.GlossaryButton />
          </Notebook.Header>
          <div className="protocol-head">
            <h4>
              <div className="hexagon">
                <IconHexagon
                  style={{
                    position: "absolute",
                    top: "16px",
                    left: "18px",
                    color: "white",
                    height: "31.1px",
                  }}
                />
              </div>
              <span className="listIndex">{props.currentMenu.number}</span>
              <button
                aria-label="Protocol menu button. Select to hide the Protocol instructions and simulation and display the menu."
                className="protocol-title-btn"
                onClick={() => props.setNoteBookSection(props.prevMenuValue)}
              >
                {props.currentMenu.title}
              </button>
            </h4>
          </div>
          <ObjectivesContainer
            nextSection={props.nextMenuValue}
            stepData={props.stepData}
            goToSection={props.goToSection}
            currentSection={props.currentMenu.value}
          />
        </Notebook.IndexBlock>
      )}
      {props.includeScene && (
        <Notebook.ContentBlock className="book_content">
          <Notebook.ContentBody className="spreadsheet_content_body">
            <Spreadsheet
              spreadsheet={props.simData}
              sectionId={props.currentMenu?.value}
            />
          </Notebook.ContentBody>
        </Notebook.ContentBlock>
      )}
    </div>
  );
}
